const podvapekits = {
    id: 'podvapekits',
    publicSiteName: 'Pod Vape Kits',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#a81342',
            secondary: '#011a5c',
            color1: '#DA2a62',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/podvapekits/favicon.ico',
        logo: '/podvapekits/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default podvapekits